import Button from '@ui/buttons/Button'
import PayNowPriceBadge from './PayNowPriceBadge'
import { PayNowButtonProps } from './types'

export default function PayNowButton({ price, ...rest }: PayNowButtonProps) {
  return (
    <Button
      {...rest}
      variant={price > 0 ? 'outlined' : 'filled'}
      iconEnd="arrow-narrow-right"
      suffix={<PayNowPriceBadge value={price} />}
    />
  )
}
